import { render, staticRenderFns } from "./AIOptimizeButton.vue?vue&type=template&id=6ae19bfa&scoped=true"
import script from "./AIOptimizeButton.vue?vue&type=script&lang=js"
export * from "./AIOptimizeButton.vue?vue&type=script&lang=js"
import style0 from "./AIOptimizeButton.vue?vue&type=style&index=0&id=6ae19bfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae19bfa",
  null
  
)

export default component.exports